import axios from "../utils/axios";

export const getBlogCategories = async (params) => {
    try {
        const { data } = await axios.get('/blog-categories', { params });
        return data;
    } catch (error) {
        console.error("~ getBlogCategories ~ error:", error);
        throw error;
    }
};

export const getBlogCategoryById = async (id) => {
    try {
        const { data } = await axios.get(`/blog-categories/${id}`);
        return data;
    } catch (error) {
        console.error("~ getBlogCategoryById ~ error:", error);
        throw error;
    }
};

export const createBlogCategory = async (categoryData) => {
    try {
        const { data } = await axios.post('/blog-categories', categoryData);
        return data;
    } catch (error) {
        console.error("~ createBlogCategory ~ error:", error);
        throw error;
    }
};

export const updateBlogCategory = async (id, categoryData) => {
    try {
        const { data } = await axios.put(`/blog-categories/${id}`, categoryData);
        return data;
    } catch (error) {
        console.error("~ updateBlogCategory ~ error:", error);
        throw error;
    }
};

export const deleteBlogCategory = async (id) => {
    try {
        const { data } = await axios.delete(`/blog-categories/${id}`);
        return data;
    } catch (error) {
        console.error("~ deleteBlogCategory ~ error:", error);
        throw error;
    }
};

export const forceDeleteBlogCategory = async (id) => {
    try {
        const { data } = await axios.delete(`/blog-categories/${id}/force`);
        return data;
    } catch (error) {
        console.error("~ forceDeleteBlogCategory ~ error:", error);
        throw error;
    }
};

export const restoreBlogCategory = async (id) => {
    try {
        const { data } = await axios.post(`/blog-categories/${id}/restore`);
        return data;
    } catch (error) {
        console.error("~ restoreBlogCategory ~ error:", error);
        throw error;
    }
};

export const massDestroyBlogCategories = async (data) => {
    try {
        const response = await axios.delete('/blog-categories/mass-destroy', { data });
        return response.data;
    } catch (error) {
        console.error("~ massDestroyBlogCategories ~ error:", error);
        throw error;
    }
};

export const massForceDeleteBlogCategories = async (data) => {
    try {
        const response = await axios.delete('/blog-categories/mass-force-delete', { data });
        return response.data;
    } catch (error) {
        console.error("~ massForceDeleteBlogCategories ~ error:", error);
        throw error;
    }
};

export const massRestoreBlogCategories = async (data) => {
    try {
        const response = await axios.post('/blog-categories/mass-restore', data);
        return response.data;
    } catch (error) {
        console.error("~ massRestoreBlogCategories ~ error:", error);
        throw error;
    }
};
